import { render, staticRenderFns } from "./gb-error-status.vue?vue&type=template&id=3b65a337&"
import script from "./gb-error-status.vue?vue&type=script&lang=js&"
export * from "./gb-error-status.vue?vue&type=script&lang=js&"
import style0 from "./gb-error-status.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports